import CheckoutConsents from './CheckoutConsents';

export default CheckoutConsents;
